module.exports = __webpack_public_path__ + "assets/db1462903d08eddaaa303cca1e43394e.png";